import Vue from 'vue';
import Vuex from 'vuex';
import App from './App.vue';
import router from './router';
import store from './store';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
//import 'formiojs/dist/formio.full.min.css'
import i18n from './i18n';
import _ from 'lodash';
import { getCommunityName, getCommunityId } from '@/api/community/communityApi';
import * as constants from '@/utils/constants.js';
import '@/icons';

Vue.prototype.$constants = constants;

Vue.prototype.getCommunityId = function () {
	return getCommunityId();
};
Vue.prototype.getCommunityName = function () {
	return getCommunityName();
};

Vue.prototype.hasPrivilege = function (_privaleges) {
	// 确保 _privaleges 是数组，如果不是则转换为数组
	const privilegesToCheck = Array.isArray(_privaleges) ? _privaleges : [_privaleges];

	// 从本地存储获取用户权限
	let userPrivileges = localStorage.getItem('hc_staff_privilege');

	// 如果存在用户权限，则转换为数组
	if (userPrivileges) {
		userPrivileges = userPrivileges.split(',');
	} else {
		// 如果没有权限数据，直接返回 false
		return false;
	}

	// 检查用户是否有任一所需权限
	return privilegesToCheck.some(item => userPrivileges.includes(item));
};

Vue.prototype.toDoc = function (url) {
	window.open('http://www.homecommunity.cn/' + url, '_blank');
};

Vue.prototype.$getUser = function () {
	let user = JSON.parse(localStorage.getItem('user'));
	return user;
};

Vue.prototype.$menu = {
	// 获取 label
	getLabel(type, value) {
		if (!type || !value) return '-';
		const menuState = store.state.enumStore;
		if (!menuState || !menuState.menuMap) return '-';
		const map = menuState.menuMap[type];
		return map ? map.get(String(value)) : '-';
	},

	// 获取列表
	getList(type) {
		if (!type) return [];
		const menuState = store.state.enumStore;
		if (!menuState || !menuState.menuRaw || !menuState.menuRaw[type]) return [];
		return menuState.menuRaw[type].filter(e => !!e.value) || [];
	},
};

const requireComponent = require.context(
	'./components/common', // 组件目录
	false, // 不递归
	/[A-Z]\w+\.(vue|js)$/ // 匹配文件名：大写开头
);

requireComponent.keys().forEach(fileName => {
	const componentConfig = requireComponent(fileName);
	const componentName = fileName.replace(/^\.\/(.*)\.\w+$/, '$1'); // 文件名转组件名
	Vue.component(componentName, componentConfig.default || componentConfig);
});

Vue.use(Vuex);
Vue.use(ElementUI);
Vue.config.productionTip = false;

new Vue({
	router,
	store,
	i18n,
	render: h => h(App),
}).$mount('#app');
